module.exports = __webpack_public_path__ + "static/monitors-440f04fa1768e538a9f8a376a3347233.jpg";